<template>
  <div class="deatial_store">
    <vs-breadcrumb
      class="mb-6"
      :items="
        index_id
          ? [
              {
                title: '供应商',
                url: '/store/list',
              },
              {
                title: '编辑供应商',
                active: true,
              },
            ]
          : [
              {
                title: '供应商',
                url: '/store/list',
              },
              {
                title: '创建供应商',
                active: true,
              },
            ]
      "
    ></vs-breadcrumb>

    <vx-card class="mb-6">
      <vs-tabs color="rgba(115,103,240,1)">
        <vs-tab label="店铺基本信息">
          <div class="vx-row mb-6 mt-2 sm:w-1/2 ml-6">
            <div class="vx-col sm:w-1/6 flex">
              <span>供应商名称</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <vs-input class="w-full" v-model="store_name" />
            </div>
          </div>

          <div class="vx-row mb-6 sm:w-1/2 ml-6">
            <div class="vx-col sm:w-1/6 flex">
              <span>供应商描述</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <vs-textarea class="w-full" v-model="store_desc" />
            </div>
          </div>

          <!-- 供应商管理员 -->
          <div class="vx-row mb-6 sm:w-1/2 ml-6">
            <div class="vx-col sm:w-1/6 flex">
              <span>供应商管理员</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <vs-input class="w-full" v-model="owner_name" />
            </div>
          </div>

          <div class="vx-row mb-6 sm:w-1/2 ml-6">
            <div class="vx-col sm:w-1/6 flex">
              <span>供应商logo</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <vs-alert active="true" class>
                尺寸: 800*640(宽高比5:4), 支持的图片格式: jpg, jpeg, png
              </vs-alert>
              <div class="w-full flex flex-col" style="align-items: center">
                <div v-if="index_id" class="mt-2 mb-2">
                  <image-item :item="fetchImgObj">
                    <template slot="action-buttons">
                      <div class="flex flex-wrap">
                        <div
                          class="
                            item-view-primary-action-btn
                            p-3
                            flex flex-grow
                            items-center
                            justify-center
                            cursor-pointer
                          "
                        >
                          <div
                            class="item_logo_pic_change_c"
                            @click="editImagePopUpActive = true"
                          >
                            <span
                              class="text-sm font-semibold ml-2 text-primary"
                              >修改logo</span
                            >
                            <!-- <vs-button class="edit_logo_btn" @click="editImagePopUpActive = true" color="primary" type="border">修改logo</vs-button> -->
                          </div>
                        </div>
                      </div>
                    </template>
                  </image-item>
                </div>
                <div class v-else>
                  <vs-upload
                    limit="1"
                    :action="uploadImgUrl"
                    fileName="file"
                    :data="uploadImageData"
                    @on-success="successUpload"
                    @on-error="showUploadError"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row mb-6 sm:w-1/2 ml-6">
            <div class="vx-col sm:w-1/6 flex">
              <span>店铺开关</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <vs-tooltip text="店铺开关">
                <vs-switch v-model="is_publish_store" />
              </vs-tooltip>
            </div>
          </div>

          <vs-divider
            position="left"
            class="text-bold vx-row mb-8"
            v-if="!index_id"
            >确认以上信息无误, 提交创建表单</vs-divider
          >
          <vs-divider v-else position="left" class="text-bold vx-row mb-8"
            >确认以上信息无误, 提交修改表单</vs-divider
          >

          <div class="vx-row">
            <div class="vx-col w-full flex justify-center">
              <vs-button class="mr-3 mb-2" @click="submitData">提交</vs-button>
              <vs-button
                id="shop-reset"
                color="primary"
                type="border"
                class="mb-2"
                @click="shopReset"
                >重置</vs-button
              >
            </div>
          </div>
        </vs-tab>
        <vs-tab label="推单设置" v-if="index_id">
          <div class="overflow-x-auto w-full">
            <div class="p-2">
              <vs-radio
                class="mr-2"
                v-model="configObj.customs"
                vs-name="radios1"
                vs-value="CD"
                >成都信通</vs-radio
              >
              <vs-radio
                v-model="configObj.customs"
                vs-name="radios1"
                vs-value="NC"
                >单一窗口</vs-radio
              >
            </div>
          </div>

          <div class="overflow-x-auto w-full">
            <div class="con-exemple-prompt p-2">
              <span>业务状态 * 1-暂存，2-申报</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="appStatus"
                v-model="configObj.appStatus"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>报送类型 * 1-新增，2-变更</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="appType"
                v-model="configObj.appType"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>进出口标记 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="ieFlag"
                v-model="configObj.ieFlag"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>贸易方式 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="tradeMode"
                v-model="configObj.tradeMode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>运输方式 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="trafMode"
                v-model="configObj.trafMode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>订单类型 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="orderType"
                v-model="configObj.orderType"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>监管场所代码:</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="loctNo"
                v-model="configObj.loctNo"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>币制 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="currency"
                v-model="configObj.currency"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>起运国 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="country"
                v-model="configObj.country"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>包装种类代码:</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="wrapType"
                v-model="configObj.wrapType"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>订单中包裹件数 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="packNo"
                v-model="configObj.packNo"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>申报海关代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="customsCode"
                v-model="configObj.customsCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>口岸海关代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="portCode"
                v-model="configObj.portCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>订购人证件类型 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="buyerIdType"
                v-model="configObj.buyerIdType"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>支付人证件类型 * 1-身份证</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="payerIdType"
                v-model="configObj.payerIdType"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>担保企业编码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="assureCode"
                v-model="configObj.assureCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>账册编号 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="emsNo"
                v-model="configObj.emsNo"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>电商企业代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="ebcCode"
                v-model="configObj.ebcCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>电商企业名称 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="ebcName"
                v-model="configObj.ebcName"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>电商平台代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="ebpCode"
                v-model="configObj.ebpCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>电商平台名称 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="ebpName"
                v-model="configObj.ebpName"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>申报企业代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="agentCod"
                v-model="configObj.agentCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>申报企业名称 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="agentName"
                v-model="configObj.agentName"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>区内企业代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="areaCode"
                v-model="configObj.areaCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>区内企业名称 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="areaName"
                v-model="configObj.areaName"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>物流企业代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="logisticsCode"
                v-model="configObj.logisticsCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>物流企业名称 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="logisticsName"
                v-model="configObj.logisticsName"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>支付企业代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="payCode"
                v-model="configObj.payCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>支付企业名称 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="payName"
                v-model="configObj.payName"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>报文传输模式 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="dxpMode"
                v-model="configObj.dxpMode"
              />
            </div>
          </div>

          <div class="overflow-x-auto w-full">
            <div class="con-exemple-prompt p-2">
              <span>订单传输企业代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="orderCopCode"
                v-model="configObj.orderCopCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>订单传输企业名称 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="orderCopName"
                v-model="configObj.orderCopName"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>订单报文传输编号 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="orderDxpId"
                v-model="configObj.orderDxpId"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>订单公服企业身份:</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="order_keyInfo"
                v-model="configObj.order_keyInfo"
              />
            </div>
          </div>

          <div class="overflow-x-auto w-full">
            <div class="con-exemple-prompt p-2">
              <span>清单传输企业代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="inventoryCopCode"
                v-model="configObj.inventoryCopCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>清单传输企业名称 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="inventoryCopName"
                v-model="configObj.inventoryCopName"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>清单报文传输编号 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="inventoryDxpId"
                v-model="configObj.inventoryDxpId"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>清单公服企业身份:</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="inventory_keyInfo"
                v-model="configObj.inventory_keyInfo"
              />
            </div>
          </div>

          <div class="overflow-x-auto w-full mb-10">
            <div class="con-exemple-prompt p-2">
              <span>运单传输企业代码 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="logisticsCopCode"
                v-model="configObj.logisticsCopCode"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>运单传输企业名称 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="logisticsCopName"
                v-model="configObj.logisticsCopName"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>运单报文传输编号 *</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="logisticsDxpId"
                v-model="configObj.logisticsDxpId"
              />
            </div>
            <div class="con-exemple-prompt p-2">
              <span>运单公服企业身份:</span><br />
              <vs-input
                class="min-w-_200"
                placeholder="logistics_keyInfo"
                v-model="configObj.logistics_keyInfo"
              />
            </div>
          </div>

          <vs-divider
            position="left"
            class="text-bold vx-row mb-8"
            v-if="!index_id"
            >确认以上信息无误, 提交创建表单</vs-divider
          >
          <vs-divider v-else position="left" class="text-bold vx-row mb-8"
            >确认以上信息无误, 提交修改表单</vs-divider
          >

          <!-- 提交或重置 -->
          <div class="vx-row mt-8 mb-8">
            <div class="vx-col w-full flex justify-center">
              <vs-button class="mr-3 mb-2" @click="confirm">提交</vs-button>
              <vs-button
                id="push-reset"
                color="primary"
                type="border"
                class="mb-2"
                @click="pushReset"
                >重置</vs-button
              >
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>

    <!-- 供应商logo修改pop -->
    <vs-popup
      title="供应商logo"
      v-if="index_id"
      :active.sync="editImagePopUpActive"
    >
      <div class="mb-6">
        <div class="b-a">
          <vs-upload
            limit="1"
            :action="uploadImgUrl"
            fileName="file"
            :data="uploadImageData"
            @on-success="successUpload1"
            @on-error="showUploadError"
          />
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import storeRepo from '@/repo/store'
import ImageItem from './components/ImageItem.vue'
export default {
  data() {
    return {
      customs: 'CD',
      is_publish_store: 1,
      index_id: '',
      store_name: '',
      store_desc: '',
      owner_name: '',
      postData: {},
      btnDisabled: false,
      image: '',
      uploadImageData: { type: 1 },
      uploadImgUrl: `${env.API_HOST}admin/store/image/upload`,
      fetchImgObj: { image: '' },
      configObj: {},
      editImagePopUpActive: false,
    }
  },

  components: {
    ImageItem,
  },

  created() {
    if (this.$route.query.id) {
      this.index_id = this.$route.query.id
      this.fetch()
    }
  },

  methods: {
    /**
     * @description fetch 供应商详情和供应商推单信息
     */
    fetch: function () {
      this.$vs.loading()
      let pa = {
        id: this.index_id,
      }
      let that = this
      storeRepo.fetchConfigDetail(pa, (error, resp) => {
        if (resp.code == 0) {
          if (Array.isArray(resp.data) && !resp.data.length) {
            that.configObj = JSON.parse(JSON.stringify({}))
          } else {
            // if (resp.data.hasOwnProperty('payCode')) {
            //   delete resp.data.payCode
            //   delete resp.data.payName
            // }
            that.configObj = JSON.parse(JSON.stringify(resp.data))
            // console.log(that.configObj)
          }
        }
      })

      storeRepo.fetchDetail(pa, (error, resp) => {
        that.$vs.loading.close()
        if (resp.code == 0) {
          that.store_name = resp.data.store_name
          that.store_desc = resp.data.store_desc
          that.owner_name = resp.data.owner_name
          that.fetchImgObj.image = resp.data.store_logo
        } else {
          that.openNotify(resp.msg, 'danger')
        }
      })
    },

    /**
     * @description 编辑海关推单
     */
    confirm: function () {
      // console.log(this.configObj.wrapType)
      // console.log(this.configObj.order_keyInfo)
      //  console.log(typeof this.configObj.order_keyInfo)
      // //编辑
      // if (typeof this.configObj.order_keyInfo == 'number') {
      //   this.configObj.order_keyInfo = String(this.configObj.order_keyinfo)
      // }
      // if (this.configObj.inventory_keyInfo == 'number') {
      //   this.configObj.inventory_keyInfo = String(
      //     this.configObj.inventory_keyInfo
      //   )
      // }
      // if (this.configObj.logistics_keyInfo == 'number') {
      //   this.configObj.logistics_keyInfo = String(
      //     this.configObj.logistics_keyInfo
      //   )
      // }
      let postParams = JSON.parse(JSON.stringify(this.configObj))
      this.validateConfig(postParams)
    },

    validateConfig: function (pa) {
      if (
        pa.appStatus &&
        pa.appType &&
        pa.ieFlag &&
        pa.tradeMode &&
        pa.trafMode &&
        pa.orderType &&
        pa.currency &&
        pa.country &&
        pa.packNo &&
        pa.customsCode &&
        pa.portCode &&
        pa.buyerIdType &&
        pa.payerIdType &&
        pa.assureCode &&
        pa.emsNo &&
        pa.ebcCode &&
        pa.ebcName &&
        pa.ebpCode &&
        pa.ebpName &&
        pa.agentCode &&
        pa.agentName &&
        pa.areaCode &&
        pa.areaName &&
        pa.logisticsCode &&
        pa.logisticsName &&
        pa.payCode &&
        pa.payName &&
        pa.dxpMode &&
        pa.orderCopCode &&
        pa.orderCopName &&
        pa.orderDxpId &&
        pa.inventoryCopCode &&
        pa.inventoryCopName &&
        pa.inventoryDxpId &&
        pa.logisticsCopCode &&
        pa.logisticsCopName &&
        pa.logisticsDxpId
      ) {
        let that = this
        // if (!pa.keyInfo) {
        //   delete pa.keyInfo
        // }
        // if (!pa.loctNo) {
        //   delete pa.loctNo
        // }
        // if (!pa.wrapType) {
        //   delete pa.wrapType
        // }
        storeRepo.editPushConfig(pa, that.index_id, (error, resp) => {
          console.log(resp)
          if (resp.code == 0) {
            that.openNotify(resp.msg, 'success')
          } else {
            that.openNotify(resp.msg)
          }
        })
      } else {
        let that = this
        let s_array = [
          'appStatus',
          'appType',
          'ieFlag',
          'tradeMode',
          'trafMode',
          'orderType',
          'currency',
          'country',
          'packNo',
          'customsCode',
          'portCode',
          'buyerIdType',
          'payerIdType',
          'assureCode',
          'emsNo',
          'ebcCode',
          'ebcName',
          'ebpCode',
          'ebpName',
          'agentCode',
          'agentName',
          'areaCode',
          'areaName',
          'logisticsCode',
          'logisticsName',
          'payCode',
          'payName',
          'dxpMode',
          'orderCopCode',
          'orderCopName',
          'orderDxpId',
          'inventoryCopCode',
          'inventoryCopName',
          'inventoryDxpId',
          'logisticsCopCode',
          'logisticsCopName',
          'logisticsDxpId',
        ]
        for (let i = 0; i < s_array.length; i++) {
          const element = s_array[i]
          if (pa[element] == undefined || String(pa[element]).trim() == '') {
            that.openNotify(`${element}为必填项，请完善推单设置表单`)
            break
          }
        }
        return
      }
    },

    /**
     * @description 提交保存供应商信息
     */
    submitData: function () {
      if (this.store_name === '') {
        this.openNotify('供应商名称不能为空')
        return
      } else if (this.store_desc === '') {
        this.openNotify('供应商描述不能为空')
        return
      } else if (this.owner_name == '') {
        this.openNotify('供应商管理员不能为空')
        return
      } else {
        //开始提交表单
        let postData = {
          store_name: this.store_name,
          store_desc: this.store_desc,
          owner_name: this.owner_name,
          store_logo: this.fetchImgObj.image
            ? this.fetchImgObj.image
            : this.image,
          is_publish: this.is_publish_store,
        }
        if (!postData.store_logo) {
          this.openNotify('供应商logo不能为空')
          return
        }
        let that = this
        if (that.index_id) {
          //编辑供应商信息
          storeRepo.edit(postData, that.index_id, (error, resp) => {
            let color = 'danger'
            if (resp.code == 0) {
              color = 'success'
              that.$router.push({ name: 'shopList' })
            }
            that.openNotify(resp.msg, color)
          })
          // let postParams = JSON.parse(JSON.stringify(this.configObj));
          // that.validateConfig(postParams,postData);
        } else {
          //创建
          storeRepo.create(postData, (error, resp) => {
            let color = 'danger'
            if (resp.code == 0) {
              color = 'success'
              that.$router.push({ name: 'shopList' })
            }
            that.openNotify(resp.msg, color)
          })
        }
      }
    },

    /**
     * @description 创建upload
     */
    successUpload: function (event) {
      let responseText = event.currentTarget.responseText
      responseText = JSON.parse(responseText)
      const image = responseText.data
      this.image = image.url
    },

    successUpload1: function (event) {
      if (this.index_id && this.editImagePopUpActive) {
        let responseText = event.currentTarget.responseText
        responseText = JSON.parse(responseText)
        if (responseText) {
          this.editImagePopUpActive = false
        }
        this.fetchImgObj.image = responseText.data.url
      }
    },

    showUploadError: function (event) {},

    openNotify: function (msg, color = 'danger') {
      this.$vs.notify({
        position: 'bottom-center',
        color: color,
        title: '操作提示',
        text: msg,
      })
      return false
    },
    shopReset() {
      this.store_name = ''
      this.store_desc = ''
      this.owner_name = ''
      let a = setTimeout(() => {
        let btn = document.getElementById('shop-reset')
        btn.blur()
        clearTimeout(a)
      }, 100)
    },
    pushReset() {
      this.configObj = {}
      let a = setTimeout(() => {
        let btn = document.getElementById('push-reset')
        btn.blur()
        clearTimeout(a)
      }, 100)
    },
  },
}
</script>

<style lang="scss">
.deatial_store .b-a {
  border: 1px solid #f5f5f5;
}
.deatial_store .edit_logo_btn {
  white-space: nowrap;
}
.min-w-_200 {
  max-width: 178px !important;
}
.deatial_store .con-exemple-prompt {
  display: inline-block !important;
}
</style>
